import React, { FunctionComponent } from 'react';
import { Button } from 'antd';
import { openModal } from '@stores/modals';

import css from './PushListHeader.module.less';
import useTranslate from '@hooks/useTranslate';
import componentContent from './PushListHeader.content.json';
import { PlusOutlined } from '@ant-design/icons';

interface PushListProps {}

const PushListHeader: FunctionComponent<PushListProps> = () => {
  const content = useTranslate(componentContent);

  return (
    <div className={css.root}>
      <div className={css.selectorsContainer}>
        <Button
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => openModal({ name: 'push' })}
        >
          {content.add}
        </Button>
      </div>
    </div>
  );
};

export default PushListHeader;
